module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "value": _vm.value,
      "max-width": "400px",
      "persistent": ""
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "title"
  }, [_vm._v("\n      Assign Campaign to the Post\n    ")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "body-2"
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.campaignList,
      "label": "Choose Campaigns in IMS:",
      "item-value": "id",
      "item-text": "name"
    },
    model: {
      value: (_vm.selectedCampaignID),
      callback: function($$v) {
        _vm.selectedCampaignID = $$v
      },
      expression: "selectedCampaignID"
    }
  }), _vm._v(" "), (_vm.postData.length) ? _c('table', {
    staticClass: "post-table"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-left"
  }, [_vm._v("Influencer")]), _vm._v(" "), _c('th', {
    staticClass: "text-left"
  }, [_vm._v("Campaign")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.postData), function(item, index) {
    return _c('tr', {
      key: item._id || index
    }, [_c('td', {
      staticClass: "text-xs-justify pa-1"
    }, [(item.author && item.author.tiktokHandle) ? _c('a', {
      attrs: {
        "href": 'https://www.tiktok.com/@' + item.author.tiktokHandle,
        "target": "_blank"
      }
    }, [_c('img', {
      attrs: {
        "src": "/static/img/tiktok-32.png",
        "width": "20px"
      }
    }), _vm._v(" @" + _vm._s(item.author.tiktokHandle))]) : (item.author && item.author.youtubeHandle) ? _c('a', {
      attrs: {
        "href": 'https://youtube.com/' + item.author.youtubeHandle,
        "target": "_blank"
      }
    }, [_c('v-icon', [_vm._v("mdi-youtube")]), _vm._v(" @" + _vm._s(item.author.youtubeHandle))], 1) : (item.author && item.author.instagramHandle) ? _c('a', {
      attrs: {
        "href": 'https://instagram.com/' + item.author.instagramHandle,
        "target": "_blank"
      }
    }, [_c('v-icon', {
      attrs: {
        "color": "#000000",
        "small": ""
      }
    }, [_vm._v("mdi-instagram")]), _vm._v(" @" + _vm._s(item.author.instagramHandle))], 1) : _c('span', [_vm._v("-")])]), _vm._v(" "), _c('td', {
      staticClass: "text-xs-left"
    }, [_vm._v(_vm._s(item.campaignName || '-'))])])
  }), 0)]) : _vm._e()], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "red",
      "text": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "green",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.assignCampaign()
      }
    }
  }, [_vm._v("Save")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5bcf8a5c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Post/AssignCampaignMultipleModal.vue
// module id = 2143
// module chunks = 0